export default "__VITE_ASSET__d6dfe65b__"